import { getVariation } from '@vp/ab-reader';
import { ITrackingEventData } from '../../types/app-interfaces';
import { WindowType } from '../../types/global-window-type';
import { getChatConfig } from './chat-config-utils';

declare const window: WindowType;

/** Fn to track events */
export const trackEvent = (eventName: string, eventDetails: ITrackingEventData) => {
  const { experimentInfo } = getChatConfig();
  let additionalProperties = {};
  /** Add experiment info if experiment is enabled */
  if (experimentInfo?.isExperimentEnabled) {
    const varKey = getVariation(experimentInfo.experimentName);
    if (varKey) {
      additionalProperties = { experimentName: experimentInfo.experimentName, variationName: varKey };
    }
  }
  console.info('trackEvent', eventName, { eventDetails }, { additionalProperties });
  /** send tracking data */
  if (window?.tracking?.track) {
    window?.tracking?.track(eventName, { ...eventDetails, ...additionalProperties });
  }
};
